import React from "react";

const IconId = (props) => {
  return (
    <svg width={props.width || "22"} height={props.height || "22"} viewBox="0 0 16.726 10.032" {...props}>
      <g
        id="Group_2815"
        dataname="Group 2815"
        transform="translate(395.633 -413.895)"
      >
        <g
          id="Group_2812"
          dataname="Group 2812"
          transform="translate(-392.635 415.966)"
        >
          <g
            id="Group_1822"
            dataname="Group 1822"
            transform="translate(0.554 1)"
          >
            <path
              id="Path_3458-2"
              dataname="Path 3458-2"
              d="M-385.695,418.293a1.241,1.241,0,0,0-.922-.42,1.238,1.238,0,0,0-.918.42,1.375,1.375,0,0,0-.323,1.1c.108.905.571,1.447,1.24,1.447s1.137-.541,1.244-1.447A1.376,1.376,0,0,0-385.695,418.293Z"
              transform="translate(388.477 -417.873)"
              fill="none"
              stroke={props.stroke || "#000"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_9217"
              dataname="Path 9217"
              d="M-389.6,427.464a1.4,1.4,0,0,1,.17-.252,1.87,1.87,0,0,1,.665-.5,2.461,2.461,0,0,1,1.079-.24,2.146,2.146,0,0,1,1.918,1"
              transform="translate(389.602 -423.456)"
              fill="none"
              stroke={props.stroke || "#000"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
          <line
            id="Line_247"
            dataname="Line 247"
            x2="2.706"
            transform="translate(7.264 1.593)"
            fill="none"
            stroke={props.stroke || "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <line
            id="Line_248"
            dataname="Line 248"
            x2="1.562"
            transform="translate(7.264 4.414)"
            fill="none"
            stroke={props.stroke || "#000"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
        <rect
          id="Rectangle_6177"
          dataname="Rectangle 6177"
          width="15.726"
          height="9.032"
          rx="4"
          transform="translate(-395.133 414.395)"
          fill="none"
          stroke={props.stroke || "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconId;
